import React from 'react';

import LinksPageLayout
  from 'components/dashboard/links-content/links-layout/LinksPageLayout';
import LinksPageContent from 'components/dashboard/links-content/LinksPageContent';


const DashboardCommonLinksPage = () => (
  <LinksPageLayout activeLinksPage="common">
    <LinksPageContent />
  </LinksPageLayout>
);

export default DashboardCommonLinksPage;
